export class RatesReportRequest {
  fiscalPeriodFrom: null | any = null;
  fiscalPeriodTo: null | any = null;

  peerGroup: string[] = [];
  practiceGroup: string[] = [];
  office: string[] = [];
}
